import React from 'react';
import Chip from '@mui/joy/Chip';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';

interface SaleStatusChipProps {
  status: string;
}

const labelForStatus = (status: string): string => {
  switch (status) {
    case 'completed':
      return 'Completada';
    case 'cancelled':
      return 'Cancelada';
    case 'paid_pending':
      return 'Pagada pendiente';
    default:
      return 'Pendiente';
  }
};

const SaleStatusChip: React.FC<SaleStatusChipProps> = ({ status }) => {
  let color: 'success' | 'danger' | 'warning' | 'neutral' = 'warning';
  let icon: React.ReactNode = <HourglassEmptyRoundedIcon />;
  if (status === 'completed') {
    color = 'success';
    icon = <CheckCircleOutlineRoundedIcon />;
  } else if (status === 'cancelled') {
    color = 'danger';
    icon = <CancelOutlinedIcon />;
  } else if (status === 'paid_pending') {
    color = 'neutral';
    icon = <PaymentsRoundedIcon />;
  }
  return (
    <Chip size="sm" variant="soft" color={color} startDecorator={icon}>
      {labelForStatus(status)}
    </Chip>
  );
};

export default SaleStatusChip;
